<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import { Base64 } from "js-base64";
//入口写入缓存店铺id
const params = new URLSearchParams(window.location.search);
const store_id = params.get('store_id');
if(store_id){
  localStorage.setItem("ticket_storeId", store_id);
}
const param_ticket_userInfo = params.get('userInfo');//聚合登录传过来的用户信息
if(param_ticket_userInfo){
  localStorage.setItem("ticket_userInfo", decodeURIComponent(Base64.decode(param_ticket_userInfo)));

  // 构造新的URL查询字符串，去除userInfo参数 (防止直接分享链接带上用户信息)
  const newParams = new URLSearchParams(params);
  newParams.delete('userInfo');
  // 获取当前页面的URL，不包括查询字符串
  const currentUrlWithoutParams = window.location.origin + window.location.pathname;
  // 将新构造的查询字符串附加到URL上，如果有的话
  const newUrl = currentUrlWithoutParams + (newParams.toString() ? '?' + newParams.toString() : '');
  // 重新跳转到新URL，实现刷新页面并去除userInfo参数
  window.location.href = newUrl;
}

</script>

<style>
body {
  background: white;
  /* Old browsers */
  /* FF 19+ */
  /* Chrome 20+ */
  /* Opera 12.10+ */
  /* Safari 6.0.4+ */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
